'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');
var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _get2 = require('babel-runtime/helpers/get');
var _get3 = _interopRequireDefault(_get2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _lodash = require('lodash');
var _lodash2 = _interopRequireDefault(_lodash);
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _frontendUtils = require('@import/frontend-utils');
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
var _BaseApi2 = require('../BaseApi');
var _BaseApi3 = _interopRequireDefault(_BaseApi2);
var _constants = require('../constants');
var _constants2 = _interopRequireDefault(_constants);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ObjectStoreBaseApi = function (_BaseApi) {
  (0, _inherits3.default)(ObjectStoreBaseApi, _BaseApi);
  function ObjectStoreBaseApi(endpoint) {
    var storeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    (0, _classCallCheck3.default)(this, ObjectStoreBaseApi);
    var _this = (0, _possibleConstructorReturn3.default)(this, (ObjectStoreBaseApi.__proto__ || Object.getPrototypeOf(ObjectStoreBaseApi)).call(this, endpoint || _frontendUtils.endpoints.storeBaseUrl));
    _this._storeObjectName = storeName || _this.storeObjectName;
    return _this;
  }
  (0, _createClass3.default)(ObjectStoreBaseApi, [{
    key: 'makeRequest',
    value: function makeRequest(params) {
      params.url = 'store/' + this._storeObjectName + params.url;
      return (0, _get3.default)(ObjectStoreBaseApi.prototype.__proto__ || Object.getPrototypeOf(ObjectStoreBaseApi.prototype), 'makeRequest', this).call(this, params);
    }

    /**
     * Obtains a single instance of the object from server.
     * @param  {String} objectGuid  Guid of the object to be obtained.
     * @param  {String} child       Name of the child property that should also be obtained. By default set to undefined.
     * @return {Promise}            Promise resolves with run object data, if request was successful. Otherwise promise rejects with ParameterError or ResponseError object.
     */
  }, {
    key: 'get',
    value: function get(objectGuid, child) {
      if (!ValidationUtils.isGuid(objectGuid)) {
        return Promise.reject(new _ParameterError2.default('objectGuid', objectGuid, 'guid string.'));
      }
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString, child)) {
        return Promise.reject(new _ParameterError2.default('child', child, 'non-blank string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: '/' + objectGuid,
        queryParameters: {
          child: child
        }
      });
    }

    /**
     * Obtains a list of objects from the server using their ids.
     * @param  {[String]} objectGuids Array of guid objects which should be queried.
     * @return {Promise}              Promise resolves with list of objects, if request was successful. Otherwise promise rejects with ParameterError or ResponseError object.
     */
  }, {
    key: 'getByIds',
    value: function getByIds(objectGuids) {
      var _this2 = this;
      if (!ValidationUtils.isArrayOf(ValidationUtils.isGuid, objectGuids)) {
        return Promise.reject(new _ParameterError2.default('objectGuids', objectGuids, 'array of guids.'));
      }
      return Promise.all(_lodash2.default.chunk(objectGuids, _constants2.default.BaseStoreApi.getByIds.maxIdsLimit).map(function (chunk) {
        return chunk.map(function (guid) {
          return 'id=' + guid;
        }).join('&');
      }).map(function (queryString) {
        return _this2.makeRequest({
          url: '?' + queryString
        });
      })).then(function (objectArrays) {
        return _lodash2.default.flatten(objectArrays);
      });
    }

    /**
     * Returns objects in bucket sorted by guid.
     * Parameters:
     *   Path - bucketName - the bucket - String
     *   Query - field - fields to return - String[] (optional)
     *   Query - child - children to inline - String[] (optional)
     *   Query - count - default 20, max 1000 - Integer (optional)
     *   Query - offset - return objects where guid > offset (i.e. a cursor for scrolling) - UUID (optional)
     * @param {*} queryParams Object that can contain query parameters described above.
     * @return {Promise} Promise resolves with list of objects, if request was successful. Otherwise promise rejects with ResponseError object.
     */
  }, {
    key: 'getList',
    value: function getList(queryParams) {
      return this.makeRequest({
        method: 'GET',
        url: '',
        queryParameters: queryParams
      });
    }
  }, {
    key: 'create',
    value: function create(value) {
      if (!ValidationUtils.isObject(value)) {
        return Promise.reject(new _ParameterError2.default('value', value, 'javascript object.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: '',
        body: value
      });
    }
  }, {
    key: 'update',
    value: function update(objectGuid, value) {
      if (!ValidationUtils.isGuid(objectGuid)) {
        return Promise.reject(new _ParameterError2.default('objectGuid', objectGuid, 'guid string.'));
      }
      if (!ValidationUtils.isObject(value)) {
        return Promise.reject(new _ParameterError2.default('value', value, 'javascript object.'));
      }
      return this.makeRequest({
        method: 'PATCH',
        url: '/' + objectGuid,
        body: value
      });
    }

    /**
     * Searches for store objects based on passed options.
     * INFO: Bare in mind that this function returns results in the elasticSearch response format to provide the total amount of found objects (which might be different than the actual number of returned objects, hence paging).
     * @param  {Object} options Object containing the parameters that will be passed to the search query. Those may be the properties of the particular object you are looking for.
     * @return {Promise}        Promise resolves with search results array, if request was successful. Otherwise promise rejects with ParameterError or ResponseError object.
     */
  }, {
    key: 'search',
    value: function search() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!ValidationUtils.isObject(options)) {
        return Promise.reject(new _ParameterError2.default('options', options, 'javascript object.'));
      }
      options._sort = options._sort || '_meta.creationTimestamp';
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString, options._sort)) {
        return Promise.reject(new _ParameterError2.default('_sort', options._sort, 'non-blank string.'));
      }
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString, options.q)) {
        return Promise.reject(new _ParameterError2.default('q', options.q, 'non-blank string.'));
      }
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isProperLengthString, options.q, _constants2.default.BaseStoreApi.search.maxQParameterLength)) {
        return Promise.reject(new _ParameterError2.default('q', options.q, 'shorter or equal to ' + _constants2.default.BaseStoreApi.search.maxQParameterLength + ' characters.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: '/_search',
        queryParameters: options
      });
    }

    /**
     * Searches for store objects based on passed options, and returns results for all backend data pages backend pages of a given resource
     * Eg. if your search can return more than 100 results, the `search` method would only return up to 100 results, while this method will return all results when they will get fetched from the backend.
     * WARNING: Bare in mind that this method overwrites the `_perpage` & `page` options in the object, so any values of those parameters provided by the user will not be taken into account.
     * INFO: Bare in mind that this function returns response in a different format than the search method. It returns the results directly without wrapping them in the ElasticSearch response object, so there is no need for "data.hits.hits" nagivation, the "data" is an array of results directly.
     * @param  {Object} options Object containing the parameters that will be passed to the search query. Those may be the properties of the particular object you are looking for.
     * @return {Promise}        Resolves with search results array, if request was successful. Otherwise promise rejects with ParameterError or ResponseError object.
     */
  }, {
    key: 'searchAllBatch',
    value: function searchAllBatch() {
      var _this3 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var maxResults = _constants2.default.BaseStoreApi.searchAllBatch.maxResults;
      var maxPages = _constants2.default.BaseStoreApi.searchAllBatch.maxPages;
      if (!ValidationUtils.isObject(options)) {
        return Promise.reject(new _ParameterError2.default('options', options, 'javascript object.'));
      }
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString, options.q)) {
        return Promise.reject(new _ParameterError2.default('q', options.q, 'non-blank string.'));
      }
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isProperLengthString, options.q, _constants2.default.BaseStoreApi.searchAllBatch.maxQParameterLength)) {
        return Promise.reject(new _ParameterError2.default('q', options.q, 'shorter or equal to ' + _constants2.default.BaseStoreApi.searchAllBatch.maxQParameterLength + ' characters.'));
      }
      options._perpage = maxResults;
      options.page = 1;
      return this.search(options).then(function (data) {
        if (data.hits.hits.length < data.hits.total) {
          var foundData = [].concat(data.hits.hits);
          var numberOfRequiredPages = Math.ceil(data.hits.total / maxResults);
          var promises = [];
          for (var i = 2; i <= Math.min(numberOfRequiredPages, maxPages); i++) {
            var newOptions = Object.assign({}, options, {
              page: i
            });
            promises.push(_this3.search(newOptions));
          }
          return Promise.all(promises).then(function (allResults) {
            allResults.forEach(function (singleResult) {
              return foundData.push.apply(foundData, (0, _toConsumableArray3.default)(singleResult.hits.hits));
            });
            return foundData;
          });
        } else {
          return data.hits.hits;
        }
      });
    }

    /**
     * Counts the number of objects on the server side.
     * @param  {Object} options Properties that will serve to filter the query, and limit the number of results. It allows passing parameters of the object you want to count.
     * @return {Promise}        Promise resolves with the number of found objects, if request was successful. Otherwise promise rejects with ParameterError or ResponseError object.
     */
  }, {
    key: 'count',
    value: function count() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!ValidationUtils.isObject(options)) {
        return Promise.reject(new _ParameterError2.default('options', options, 'javascript object.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: '/_count',
        queryParameters: options
      });
    }
  }, {
    key: 'getAttachment',
    value: function getAttachment(objectGuid, attachmentName, attachmentGuid) {
      if (!ValidationUtils.isGuid(objectGuid)) {
        return Promise.reject(new _ParameterError2.default('objectGuid', objectGuid, 'guid string.'));
      }
      if (!ValidationUtils.isNonEmptyOrBlankString(attachmentName)) {
        return Promise.reject(new _ParameterError2.default('attachmentName', attachmentName, 'non-empty string.'));
      }
      if (!ValidationUtils.isGuid(attachmentGuid)) {
        return Promise.reject(new _ParameterError2.default('attachmentGuid', attachmentGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: '/' + objectGuid + '/_attachment/' + attachmentName + '/' + attachmentGuid
      });
    }
  }, {
    key: 'getAttachmentDirect',
    value: function getAttachmentDirect(objectGuid, attachmentName) {
      var redirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'follow';
      if (!ValidationUtils.isGuid(objectGuid)) {
        return Promise.reject(new _ParameterError2.default('objectGuid', objectGuid, 'guid string.'));
      }
      if (!ValidationUtils.isNonEmptyOrBlankString(attachmentName)) {
        return Promise.reject(new _ParameterError2.default('attachmentName', attachmentName, 'non-empty string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: '/' + objectGuid + '/_attachment/' + attachmentName + '/_direct',
        redirect: redirect,
        retryMax: 1
      });
    }
  }, {
    key: 'sendAttachment',
    value: function sendAttachment(objectGuid, attachmentName, attachmentBlob) {
      var attachmentContentType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'application/json';
      if (!ValidationUtils.isGuid(objectGuid)) {
        return Promise.reject(new _ParameterError2.default('objectGuid', objectGuid, 'guid string.'));
      }
      if (!ValidationUtils.isNonEmptyOrBlankString(attachmentName)) {
        return Promise.reject(new _ParameterError2.default('attachmentName', attachmentName, 'non-empty string.'));
      }
      return this.makeRequest({
        method: 'PUT',
        url: '/' + objectGuid + '/_attachment/' + attachmentName,
        body: attachmentBlob,
        contentType: attachmentContentType
      });
    }
  }, {
    key: 'changeOwner',
    value: function changeOwner(objectGuid, newOwner) {
      return this.makeRequest({
        method: 'PATCH',
        url: '/' + objectGuid,
        queryParameters: {
          newOwner: newOwner
        }
      });
    }

    /**
     * Delete a instance of the object from server.
     * @param {String} objectGuid   Guid of the object to be deleted
     * @return {Promise}            Promise resolves with run object data, if request was successful. Otherwise promise rejects with ParameterError or ResponseError object.
     */
  }, {
    key: 'delete',
    value: function _delete(objectGuid) {
      if (!ValidationUtils.isGuid(objectGuid)) {
        return Promise.reject(new _ParameterError2.default('objectGuid', objectGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'DELETE',
        url: '/' + objectGuid
      });
    }
  }, {
    key: 'storeObjectName',
    get: function get() {
      return '';
    }
  }]);
  return ObjectStoreBaseApi;
}(_BaseApi3.default);
exports.default = ObjectStoreBaseApi;